import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaErrorPage, WeaTools, WeaTable, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import Title from './Title';
import { formatData } from '../../util/common';
//内容组件
class EContent extends React.Component {
    constructor(props) {
        super(props);
        const currentTab = props.edata.currenttab || props.edata.tabids[0];
        this.state = {
            tabdata: props.edata.data[currentTab],
            currentTab: currentTab,
            refresh: false,
        }
        this.handleTabData = this.handleTabData.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(!isEqual(nextProps, this.props)){
            const currentTab = nextProps.edata.currenttab || nextProps.edata.tabids[0];
            this.setState({
                tabdata: nextProps.edata.data[currentTab],
                currentTab: currentTab,
                refresh: false,
            }); 
        }
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    handleTabData(tabid){
        const { edata, config } = this.props;
        const { params } = config;
        const { currentTab } = this.state;
        this.setState({
            currentTab: tabid,
            tabdata: edata.data[tabid],
            refresh: tabid === currentTab,
        });
        setTimeout(()=>{
            this.setState({
                refresh: false,
            });
        },100);
    }
    render() {
        const { config, edata, handleRefresh, handleDelete, fontSizeMp } = this.props;
        const { tabdata, currentTab, refresh } = this.state; 
        const { eid } = config.item;
        const { contentview = {} } = config.item;
        const cstyle = tabids && tabids.length > 1 && contentview.style && contentview.style.height ? {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"} : {};
        const { tabids, titles, esetting, counts } = edata;
        let { fontStyle } = config.item;
        if(!isEmpty(fontSizeMp)) fontStyle = fontSizeMp;
        esetting.fontStyle = fontStyle;
        let contentHtml = tabdata && tabdata.length ? <WeaTable columns={formatData(tabdata[0], esetting)} showHeader={false} pagination={false} dataSource={tabdata} size="small"/>
                :
            <div className = "ant-table-placeholder">
            <span> <i className = "anticon anticon-frown"></i>{getLabel(83553, '暂无数据')}</span>
            </div>;
        const _titleProps = {
            currentTab,
            config,
            titles,
            tabids,
            counts,
            handleRefresh,
            handleDelete,
            fontSizeMp,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            handleTabData: this.handleTabData
        }
        return <div>
            <Title {..._titleProps}/>
            <div className="tabContant" id={`tabcontant_${eid}`} style={{height: cstyle.height}}>
                <Spin spinning={refresh}>{contentHtml}</Spin>
            </div>
         </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error :getLabel(385218,"对不起，该页面异常，请联系管理员！")}/>
        );
    }
}
EContent = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EContent);
export default EContent;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/blogstatus/EContent.js